export default "__VITE_ASSET__ca9a1fae__"